jQuery(function ($) {
  // Nasłuchuj zmiany metody płatności
  $(document.body).on("change", 'input[name="payment_method"]', function () {
    const paymentMethod = $(this).val();

    // Pokaż loader
    $("form.checkout").block({
      message: null,
      overlayCSS: {
        background: "#fff",
        opacity: 0.6,
      },
    });

    // Wyślij request AJAX
    $.ajax({
      type: "POST",
      url: shippingCodAjax.ajax_url,
      data: {
        action: "update_shipping_method",
        payment_method: paymentMethod,
        nonce: shippingCodAjax.nonce,
      },
      success: function (response) {
        // Zaktualizuj fragmenty strony
        if (response.fragments) {
          $.each(response.fragments, function (selector, html) {
            $(selector).replaceWith(html);
          });
        }

        // Przelicz totale
        $(document.body).trigger("update_checkout");
      },
      complete: function () {
        // Usuń loader
        $("form.checkout").unblock();
      },
    });
  });
});
